<template lang="pug">
  div
    div.mobile-menu-btn(v-show="collapse", :class="$route.name=='home'?'':'white'", @click="isOpen = !isOpen")
      span(v-for="item in 3", :key="item+'a'", :class="isOpen?'open':''")
    div(:class="collapse?$route.name=='home'?'mobile-menu':'mobile-menu white':$route.name=='home'?'menu':'menu white'", v-show="collapse && isOpen || !collapse")
      span(v-for="item in menu")
        router-link(:to="{name: item.to}") {{item.title}}
</template>
v-if="$route.name=='home'"
<script>
  export default {
    name: 'top-menu',
    props: ['collapse'],
    data: () => ({
      isOpen: false,
      menu: [
        {
          title: 'Início',
          to: 'home'
        },
        {
          title: 'Sobre',
          to: 'about'
        }
      ]
    }),
  }
</script>

<style lang="sass" scoped>
  @import './style'
</style>